import WaveSurfer from 'wavesurfer.js';

class AudioWaveformElement extends HTMLElement {
  connectedCallback() {
    if (this.source) {
      // Initialize based on src attribute rather than attaching to audio element
      this.initWaveform();
    } else {
      this.associateAudioElement();
    }
  }

  get source() {
    return this.getAttribute('src');
  }

  get audioElementId() {
    return this.getAttribute('for');
  }

  get audioElement() {
    return document.getElementById(this.audioElementId);
  }

  associateAudioElement() {
    if (this.audioElementId) {
      if (this.audioElement.readyState >= 1) {
        this.initWaveform();
      } else {
        this.audioElement.addEventListener('loadedmetadata', () => {
          this.initWaveform();
        });
      }
    }
  }

  initWaveform() {
    WaveSurfer.create({
      container: this,
      media: this.audioElement,
      src: this.source,
      barGap: 1,
      barRadius: 1,
      barWidth: 1,
      barHeight: 0.65,
      cursorColor: '#E23442',
      cursorWidth: 3,
      height: 'auto',
      progressColor: '#292929',
      waveColor: '#B7B7B6',
    });
  }
}

if (!window.customElements.get('tmp-audio-waveform')) {
  window.AudioWaveformElement = AudioWaveformElement;
  window.customElements.define('tmp-audio-waveform', AudioWaveformElement);
}
